import React, { useEffect, useState } from 'react'
import { Container, Avatar, Button, Typography, Grid, Link, Dialog, Toolbar, DialogContent, Divider, IconButton, TextField, Box } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { FormTextField } from '../controls'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import { theme } from "../ui/theme"
import { useSelector, useDispatch } from 'react-redux'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { notificationActions, accountActions, galleryActions, cartActions } from '../actions'
import { loginSchema } from '../validation/loginSchema'
import { authenticate, forgotPassword } from '../apis/accountRequests'
import { makeRequest } from '../apis/makeRequest'
import { useNavigate } from 'react-router-dom'
import PopUp from '../components/PopUp'



const fields = loginSchema.describe().fields

const styles = {
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.primary.light,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(1, 0, 1),
        color: "black",
        backgroundColor: "#B5CD7F",
        '&:hover':{
            backgroundColor:"#8BB85A",
        }
    },
}

export default function Login() {
    const loading = useSelector(state => state.spinner.loading)
    const invalidToken = useSelector(state => state.account.invalidToken)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [dialogOpen, setDialogOpen] = useState(false)
    const [serviceDialog, setServiceDialog] = useState(false)
    const [usuario, setUsuario] = useState('')

    const { control, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(loginSchema),
        reValidateMode: 'onBlur'
    })

    /*useEffect(() => {
        console.log(errors)
    }, [errors])*/

    useEffect(() => {
        if (loading)
            return

        if (invalidToken)
            dispatch(notificationActions.showError({ message: 'Token inválido al iniciar sesión' }))
    }, [invalidToken, loading, dispatch])

    const onSubmit = data => {
        // setServiceDialog(true)
        //Mantenimiento 
        makeRequest( 
            () => authenticate(data),
            res => {
                const token = res.data.token
                localStorage.setItem('token', token)
                dispatch(accountActions.logIn(token))
                dispatch(cartActions.clear())
                dispatch(galleryActions.setSearchTerm(""))
                dispatch(galleryActions.setCategoria(""))
                dispatch(galleryActions.setRubro(""))
                dispatch(galleryActions.setSubRubro(""))
                dispatch(galleryActions.setPromocion("DESTACADOS"))
                navigate("/")
            },
            err => err.response.data === undefined ?
                dispatch(notificationActions.showError({ message: 'Error de Red' })) :
                dispatch(notificationActions.showError({ message: 'Nombre de usuario o contraseña incorrecta' }))
        )
    }

    const recoverAccount = () => {
        makeRequest(
            () => forgotPassword(usuario),
            res => dispatch(notificationActions.showSuccess({ message: 'Se ha enviado un correo a su casilla de email con las instrucciones para restablecer su contraseña' })),
            err => dispatch(notificationActions.showError({ message: 'Nombre de usuario incorrecta o no registrado' }))
        )
        setDialogOpen(false)
    }

    const instructivo = `${process.env.PUBLIC_URL}/pdf/instructivo.pdf`;

    return (
        <>
            <Container component='main' maxWidth='xs'>
                <div style={styles.paper}>
                    <Avatar sx={styles.avatar}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <Typography component='h1' variant='h5'>
                        Log-in
                    </Typography>
                    <form style={styles.form} onSubmit={handleSubmit(onSubmit)}>
                        <FormTextField
                            control={control}
                            style={{ width: "100%" }}
                            name='userName'
                            margin='normal'
                            schema={fields.userName}
                            formErrors={errors.userName}
                            shrink={true}
                        />
                        <FormTextField
                            control={control}
                            style={{ width: "100%" }}
                            name='password'
                            margin='normal'
                            schema={fields.password}
                            formErrors={errors.password}
                            type='password'
                            shrink={true}
                        />
                        <FormControlLabel
                            label='Recordarme'
                            control={
                                <Checkbox control={control}
                                    name='rememberMe'
                                    color='primary' />
                            }
                        />
                        <Button variant='contained' disabled={loading} type='submit' sx={styles.submit} fullWidth>
                            Sign In
                        </Button>
                        <Box sx={{ display: "flex", justifyContent: "space-around" }}>
                            <Box >
                                <Link style={{ color: "#B5CD7F", textDecorationColor: "#B5CD7F" }} variant='caption' href="#" onClick={() => setDialogOpen(true)}> 
                                    ¿Olvidaste tu contraseña?
                                </Link>
                            </Box>
                            {/* <Box >
                                <Link style={{ color: "#B5CD7F", textDecorationColor: "#B5CD7F" }} variant='caption' href="#" onClick={() => navigate('/register')} >
                                    Quiero registrarme
                                </Link>
                            </Box> */}
                        </Box>
                        <Box sx={{ display: "flex", justifyContent: "center", mt: 1.5 }}>
                            <Link style={{ color: "#B5CD7F", textDecorationColor: "#B5CD7F" }} variant='caption' href={instructivo} download={"instructivo.pdf"} >
                                Descargar Instructivo
                            </Link>
                        </Box>
                    </form>
                </div>
            </Container>
            <PopUp open={serviceDialog} setClose={setServiceDialog} msg={'Sitio web en mantenimiento. Próximamente estaremos disponibles'} maxWidth='xs' />
            <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
                <Toolbar variant='dense'>
                    ¿Olvido su contraseña?
                    <IconButton onClick={() => setDialogOpen(false)} size='large'
                        style={{ position: 'absolute', right: 10, top: 1, color: 'inherit' }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Toolbar>
                <Divider />
                <DialogContent>
                    <Container component='main' maxWidth='xs'>
                        <Typography variant='body2' align='center'>Ingrese su usuario para recuperar su cuenta</Typography>
                        <TextField type='email' margin='dense' size='small' label='Usuario' style={{ width: "100%" }} onChange={(e) => setUsuario(e.target.value)} />
                        <Button fullWidth sx={styles.submit} onClick={() => recoverAccount()}>recuperar la cuenta</Button>
                    </Container>
                </DialogContent>
            </Dialog>
        </>
    )
}
